import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header';
import { Button, Col, Dropdown, Form, FormControl, FormLabel, FormSelect, Row, Spinner, Table, Card, Badge, Alert, Modal } from 'react-bootstrap';
import ReusableTable from '../../components/ReusableTable';
import { toast } from 'react-toastify';
import axios from '../../api/axios';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const MenuIngredients = () => {

  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);
  const { access } = useSelector((state) => state.login);
  const { email } = useSelector((state) => state.login);
  const [menuAccess, setMenuAccess] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (Array.isArray(access)) {
      const filteredAccess = access?.filter((perm) =>
        perm?.startsWith("MenuIngredients:")
      );
      setMenuAccess(filteredAccess);
    }
  }, [access]);

  const accessToken = localStorage.getItem("authToken");
  const [searchText, setSearchText] = useState('');
  const [isTouched, setIsTouched] = useState(false);
  const [ingredientsList, setIngredientsList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [isSubmitBtnLoading, setIsSubmitBtnLoading] = useState(false);
  const [categoryId, setCategoryId] = useState('');
  const [isClicked, setIsClicked] = useState(false);
  const [rawMaterialList, setRawMaterialList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [productIngredientId, setProductIngredientId] = useState('');
  const [page, setPage] = useState('1');
  const [rowsPerPage, setRowsPerPage] = useState('10');
  const [addons, setAddons] = useState([]);

  const categoryOptions = categoryList?.map((cat) => ({
    value: cat._id,
    label: cat.name,
  }));

  // Compact columns with smaller font
  const columns = [
    {
      header: "Sr.No",
      accessor: "serialNumber",
      render: (value, row) => (
        <div className="text-center" style={{ fontSize: '0.75rem', color: '#4a5568' }}>
          {row?.serialNumber || "—"}
        </div>
      ),
    },
    {
      header: "Menu Name & Ingredients",
      accessor: "product.name",
      render: (value, row) => {
        const accordionId = `accordion-${row.id || Math.random().toString(36).substr(2, 9)}`;

        return (
          <div className="w-100">
            {/* Accordion Header/Toggle */}
            <button
              className="btn btn-link text-decoration-none p-0 w-100 text-start"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#${accordionId}`}
              aria-expanded="false"
              aria-controls={accordionId}
              style={{ outline: 'none', boxShadow: 'none' }}
            >
              <div className="d-flex align-items-center justify-content-between p-1 rounded" 
                   style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                <span className="fw-medium" style={{ color: '#0E4961', fontSize: '0.8rem' }}>
                  {row?.product?.name || "—"}
                </span>
                <Badge bg="light" text="dark" style={{ fontSize: '0.65rem', padding: '0.2rem 0.5rem' }}>
                  <i className="bi bi-chevron-down me-1" style={{ fontSize: '0.65rem' }}></i>
                  {row?.rawMaterials?.length || 0}
                </Badge>
              </div>
            </button>

            {/* Accordion Content */}
            <div className="collapse mt-1" id={accordionId}>
              <div className="table-responsive">
                <Table hover size="sm" className="mb-0" style={{ fontSize: '0.7rem' }}>
                  <thead className="table-light">
                    <tr>
                      <th className="text-center" style={{ width: '40px', fontSize: '0.7rem', color: '#2d3748' }}>#</th>
                      <th className="text-start" style={{ fontSize: '0.7rem', color: '#2d3748' }}>Raw Material</th>
                      <th className="text-start" style={{ fontSize: '0.7rem', color: '#2d3748' }}>Addon Details</th>
                      <th className="text-center" style={{ fontSize: '0.7rem', color: '#2d3748', width: '80px' }}>Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {row?.rawMaterials && row?.rawMaterials?.length > 0 ? (
                      row?.rawMaterials?.map((rm, index) => (
                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
                          <td className="text-center" style={{ fontSize: '0.7rem', color: '#718096' }}>{index + 1}</td>
                          <td className="text-start">
                            <span className="fw-medium" style={{ fontSize: '0.7rem', color: '#2b6c94' }}>
                              {rm?.rawMaterial?.name || "—"}
                            </span>
                          </td>
                          <td className="text-start">
                            {rm?.addonValueDetails?.value ? (
                              <div className="d-flex flex-column" style={{ lineHeight: '1.2' }}>
                                <span className="fw-medium" style={{ fontSize: '0.7rem', color: '#b45353' }}>
                                  {rm?.addonValueDetails?.value}
                                </span>
                                <small style={{ fontSize: '0.6rem', color: '#2f855a' }}>
                                  {rm?.addonId?.title}
                                </small>
                              </div>
                            ) : (
                              <span style={{ fontSize: '0.7rem', color: '#a0aec0' }}>—</span>
                            )}
                          </td>
                          <td className="text-center">
                            <span style={{ fontSize: '0.7rem', color: '#2d3748' }}>
                              {rm?.quantity || "—"} {rm?.rawMaterial?.unit || ""}
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center py-2" style={{ fontSize: '0.7rem', color: '#a0aec0', fontStyle: 'italic' }}>
                          No ingredients
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      header: "Actions",
      accessor: null,
      render: (_, row) => (
        <div className="d-flex justify-content-center">
          <Dropdown>
            <Dropdown.Toggle variant="link" size="sm" className="border-0 shadow-none p-0">
              <i className="ri-more-2-fill" style={{ fontSize: "0.9rem", color: '#4a5568' }}></i>
            </Dropdown.Toggle>
            <Dropdown.Menu align="end" className="shadow-sm border py-1" style={{ minWidth: '100px' }}>
              {(menuAccess?.includes("MenuIngredients:update") || email === "contact@xpansecafe.com") && (
                <Dropdown.Item
                  onClick={() => navigate(`/menu/edit-menu-ingredients/${row._id}`)}
                  className="py-1 px-2"
                  style={{ fontSize: '0.75rem' }}
                >
                  <i className="ri-edit-2-line me-1 text-primary" style={{ fontSize: '0.75rem' }}></i>
                  Edit
                </Dropdown.Item>
              )}
              {(menuAccess?.includes("MenuIngredients:delete") || email === "contact@xpansecafe.com") && (
                <Dropdown.Item 
                  onClick={() => handleDeleteModal(row)}
                  className="py-1 px-2"
                  style={{ fontSize: '0.75rem' }}
                >
                  <i className="ri-delete-bin-line me-1 text-danger" style={{ fontSize: '0.75rem' }}></i>
                  Delete
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  const getIngredients = async (catId) => {
    setIsLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }

      const response = await axios.get("recipe", { headers });
      response?.data?.data?.recieps?.forEach((item, index) => {
        item.serialNumber = index + 1;
      });
      console.log("Category Id :", catId);
      
      if (catId === "" || catId === undefined) {
        setFilteredData(response?.data?.data?.recieps);
        setIngredientsList(response?.data?.data?.recieps);
      } else {
        let filteredRecipes = response?.data?.data?.recieps?.filter((rec) => rec?.product?.category === catId);
        setFilteredData(filteredRecipes);
        setIngredientsList(filteredRecipes);
        // setIngredientsList(response?.data?.data?.recieps);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        toast.error(error.response.data.error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getCategoryList = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("masters/category/get", { headers });

      if (response?.data?.status === true) {
        setCategoryList(response?.data?.data?.categories);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        toast.error(error.response.data.error);
      }
    }
  };

  const getProductsListForEdit = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("product", { headers });
      if (response?.data?.status === true) {
        setProductsList(response?.data?.data?.products);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        toast.error(error.response.data.error);
      }
    }
  };

  const getAddons = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }
      const response = await axios.get("addons?page=1&limit=1000", { headers });
      setAddons(response?.data?.data?.addons);
    } catch (error) {
      console.log("error :", error);
    }
  }

  const getRawMaterials = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("raw-material", { headers });

      if (response?.data?.status === true) {
        response?.data?.data?.rawMaterials?.forEach((item, index) => {
          item.serialNumber = index + 1;
        });
        setRawMaterialList(response?.data?.data?.rawMaterials);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        toast.error(error.response.data.error);
      }
    }
  };

  const handleOpenAddScreen = () => {
    navigate('/menu/add-menu-ingredients');
  };

  const handleSearchChange = (e) => {
    setIsTouched(true);
    setSearchText(e.target.value);
  };

  const handleSubmitData = async (e) => {
    e.preventDefault();
    if (!categoryId) {
      toast.warning("Please select a category first");
      return;
    }
    setIsClicked(true);
    setIsSubmitBtnLoading(true);
    await getIngredients(categoryId);
    setIsSubmitBtnLoading(false);
  };

  const handleDeleteModal = (data) => {
    const ingredientId = data?._id;
    setProductIngredientId(ingredientId);
    setOpenDeleteModal(true);
  }

  const handleDeleteProductIngredient = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }
      const data = {
        _id: productIngredientId,
      };
      const response = await axios.delete("recipe", { data, headers })
      if (response?.data?.status === true) {
        toast.success("Ingredient deleted successfully");
        getIngredients(categoryId);
        setOpenDeleteModal(false);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        toast.error(error.response.data.error);
      }
    } finally {
      setIsLoading(false);
    }
  }

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    setRowsPerPage(rowsPerPage);
    setPage(1);
  };

  const getPaginatedData = () => {
    const startIndex = (page - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return filteredData?.slice(startIndex, endIndex);
  };

  useEffect(() => {
    getCategoryList();
    getRawMaterials();
    getProductsListForEdit();
    getAddons();
  }, []);

  useEffect(() => {
    if (searchText && isTouched) {
      const result = ingredientsList?.filter((item) => 
        item?.product?.name?.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredData(result);
    } else {
      setFilteredData(ingredientsList);
    }
  }, [searchText, ingredientsList]);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-2 p-lg-3" style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
        <div className="container-fluid px-0">
          {/* Header Card - Compact */}
          <Card className="border-0 shadow-sm mb-3 bg-white">
            <Card.Body className="p-3">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <h6 className="fw-semibold mb-0" style={{ color: '#1e293b', fontSize: '1.2rem' }}>MENU INGREDIENTS MANAGEMENT</h6>
                  <small className="text-muted" style={{ fontSize: '0.7rem' }}>Manage ingredients for menu items</small>
                </div>
                {(menuAccess?.includes("MenuIngredients:add") || email === "contact@xpansecafe.com") && (
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handleOpenAddScreen}
                    className="d-flex align-items-center justify-content-center gap-1"
                    style={{ backgroundColor: '#0E4961', width: '150px', borderColor: '#0E4961', fontSize: '0.75rem', padding: '0.25rem 0.75rem' }}
                  >
                    <i className="ri-add-line" style={{ fontSize: '0.8rem' }}></i>
                    <span>Add New</span>
                  </Button>
                )}
              </div>
            </Card.Body>
          </Card>

          {/* Filters Card - Compact */}
          <Card className="border-0 shadow-sm mb-3 bg-white">
            <Card.Body className="p-2">
              <Row className="g-2 align-items-end">
                <Col md={4}>
                  <FormLabel className="fw-semibold mb-1" style={{ fontSize: '0.8rem', color: '#2d3748' }}>
                    Category
                  </FormLabel>
                  <Select
                    name="categoryFilter"
                    options={categoryOptions}
                    value={categoryOptions?.find((option) => option.value === categoryId) || null}
                    onChange={(selectedOption) => setCategoryId(selectedOption ? selectedOption.value : '')}
                    placeholder="Select category..."
                    isClearable
                    classNamePrefix="react-select"
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: '32px',
                        fontSize: '0.75rem',
                        borderColor: '#e2e8f0',
                        '&:hover': { borderColor: '#cbd5e0' }
                      }),
                      menu: (base) => ({ ...base, fontSize: '0.75rem' }),
                      option: (base) => ({ ...base, fontSize: '0.75rem', padding: '0.25rem 0.75rem' }),
                      placeholder: (base) => ({ ...base, fontSize: '0.75rem' }),
                      singleValue: (base) => ({ ...base, fontSize: '0.75rem' }),
                      input: (base) => ({ ...base, fontSize: '0.75rem' })
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Button 
                    className="w-100 d-flex align-items-center justify-content-center gap-1 fe-semibold" 
                    variant="success" 
                    size="sm"
                    onClick={handleSubmitData}
                    disabled={isSubmitBtnLoading}
                    style={{ height: '32px', fontSize: '0.8rem' }}
                  >
                    {isSubmitBtnLoading ? (
                      <>
                        <Spinner size="sm" style={{ width: '0.8rem', height: '0.9rem' }} />
                        <span>...</span>
                      </>
                    ) : (
                      <>
                        <i className="ri-search-line me-1" style={{ fontSize: '0.9rem' }}></i>
                        <span className='fw-semibold'>Fetch</span>
                      </>
                    )}
                  </Button>
                </Col>
                <Col md={6}>
                  <FormLabel className="fw-semibold mb-1" style={{ fontSize: '0.8rem', color: '#2d3748' }}>
                    Search
                  </FormLabel>
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0" style={{ padding: '0.25rem 0.5rem' }}>
                      <i className="ri-search-line" style={{ fontSize: '0.8rem', color: '#a0aec0' }}></i>
                    </span>
                    <FormControl
                      type="text"
                      value={searchText}
                      onChange={handleSearchChange}
                      placeholder="Search by menu name..."
                      className="border-start-0"
                      style={{ fontSize: '0.75rem', padding: '0.25rem 0.75rem', height: '32px', borderColor: '#e2e8f0' }}
                    />
                    {searchText && (
                      <Button 
                        variant="link" 
                        className="text-decoration-none position-absolute end-0 top-50 translate-middle-y me-2 p-0 border-0"
                        onClick={() => setSearchText('')}
                        style={{ zIndex: 5 }}
                      >
                        <i className="ri-close-line" style={{ fontSize: '0.8rem', color: '#a0aec0' }}></i>
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Data Display - Compact */}
          {isClicked ? (
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-2">
                {filteredData?.length > 0 ? (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-2 px-1">
                      <div>
                        <small className="fw-medium" style={{ fontSize: '0.85rem', color: '#1e293b' }}>
                          Ingredients List
                        </small>
                        <small className="text-muted ms-2" style={{ fontSize: '0.65rem' }}>
                          {getPaginatedData().length} of {filteredData.length}
                        </small>
                      </div>
                      <Badge bg="light" text="dark" style={{ fontSize: '0.6rem', padding: '0.2rem 0.5rem' }}>
                        <i className="ri-information-line me-1" style={{ fontSize: '0.6rem' }}></i>
                        Click menu to expand
                      </Badge>
                    </div>
                    
                    {(menuAccess?.includes("MenuIngredients:get") || email === "contact@xpansecafe.com") && (
                      <ReusableTable
                        columns={columns}
                        data={getPaginatedData()}
                        rowKey="serialNumber"
                        loading={isLoading}
                        currentPage={page}
                        recordsPerPage={rowsPerPage}
                        onPageChange={handlePageChange}
                        onRecordsPerPageChange={handleRowsPerPageChange}
                        totalPages={Math.ceil(filteredData.length / rowsPerPage)}
                        className="table-hover"
                        tableStyle={{ fontSize: '0.75rem' }}
                      />
                    )}
                  </>
                ) : (
                  <div className="text-center py-3">
                    <i className="ri-restaurant-line" style={{ fontSize: '1.2rem', color: '#cbd5e0' }}></i>
                    <p className="mb-0" style={{ fontSize: '0.7rem', color: '#94a3b8' }}>No ingredients found</p>
                  </div>
                )}
              </Card.Body>
            </Card>
          ) : (
            <Card className="border-0 shadow-sm bg-white">
              <Card.Body className="p-3 text-center">
                <div className="py-2">
                  <i className="ri-restaurant-line" style={{ fontSize: '1.7rem', color: '#cbd5e0' }}></i>
                  <p className="mb-0 mt-1" style={{ fontSize: '0.8rem', color: '#94a3b8' }}>
                    Select category and click Fetch
                  </p>
                </div>
              </Card.Body>
            </Card>
          )}
        </div>
      </div>

      {/* Delete Confirmation Modal - Compact */}
      <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered size="sm">
        <Modal.Header closeButton className="p-2 border-0">
          <Modal.Title style={{ fontSize: '0.85rem', color: '#1e293b' }}>
            Confirm Delete
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-2">
          <p className="mb-0" style={{ fontSize: '0.75rem', color: '#4a5568' }}>
            Are you sure you want to delete this ingredient?
          </p>
        </Modal.Body>
        <Modal.Footer className="p-2 border-0">
          <Button variant="light" size="sm" onClick={() => setOpenDeleteModal(false)} style={{ fontSize: '0.7rem', padding: '0.25rem 0.75rem' }}>
            Cancel
          </Button>
          <Button 
            variant="danger" 
            size="sm"
            onClick={handleDeleteProductIngredient}
            disabled={isLoading}
            style={{ fontSize: '0.7rem', padding: '0.25rem 0.75rem' }}
          >
            {isLoading ? (
              <Spinner size="sm" style={{ width: '0.7rem', height: '0.7rem' }} />
            ) : (
              'Delete'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  )
}

export default MenuIngredients